import { MatchmakingMatchTypes } from '@colonist/game-base-types';
import { UIWLeaderboardController } from './UIWLeaderboardController.ts';
import { showChangeRegionDialog } from '../../../shared/scripts/ui_popup/change_region_dialog/showChangeRegionDialog.ts';
import { showSimpleDialog } from '../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { uiManager } from '../EntryHomepage.ts';
export class UIDLeaderboardController extends UIWLeaderboardController {
    // eslint-disable-next-line class-methods-use-this
    managesHistory() {
        return false;
    }
    getOnRankedModeChange() {
        return ()=>this.showChangeRegionIncentivePopup();
    }
    // eslint-disable-next-line class-methods-use-this
    getCtaConfig() {
        return {
            onClickBaseGame: ()=>uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic4P),
            onClick1v1: ()=>uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic1v1),
            onClickCK: ()=>uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedCitiesAndKnights4P),
            onClickColonistRush: ()=>uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedRush4P)
        };
    }
    async fetchStickyRowData() {
        await this.data.refreshStickyRow();
    }
    showChangeRegionIncentivePopup() {
        var _ClientUserState_userState;
        const alreadyShown = StorageWrapper.getDiscordChangeRegionIncentivePopupShown();
        if (alreadyShown) return;
        if (!this.isRanked) return;
        const changedRegionManually = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.regionUpdated) != undefined;
        if (changedRegionManually) return;
        showSimpleDialog({
            title: {
                key: 'strings:popups.changeRegionIncentive.title'
            },
            body: {
                key: 'strings:popups.changeRegionIncentive.body'
            },
            onConfirm: ()=>showChangeRegionDialog()
        });
        StorageWrapper.setDiscordChangeRegionIncentivePopupShown();
    }
    get isRanked() {
        const stickyData = this.data.getState().myStickyRowData;
        if (stickyData == undefined) return true;
        if (!stickyData.loggedIn) return false;
        return stickyData.unrankedOverrideMessage == undefined;
    }
}
